import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const getBasePath = (path: string) => {
  if (path.startsWith('/en/')) {
    return path.substring(3) || '/'; // Handle '/en/' -> '/'
  }
  if (path === '/en') {
    return '/';
  }
  return path;
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const prevPathnameRef = useRef(pathname);

  useEffect(() => {
    const prevPath = prevPathnameRef.current;

    const currentBasePath = getBasePath(pathname);
    const prevBasePath = getBasePath(prevPath);

    // Only scroll to top if the base path has changed
    if (currentBasePath !== prevBasePath) {
      window.scrollTo(0, 0);
    }

    // Update the ref to the current pathname for the next render
    prevPathnameRef.current = pathname;
  }, [pathname]);

  return null;
};

export default ScrollToTop;
